import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendExtractedBlogInstructions,
  BackendMutationExtractBlogInstructionsFromUrlArgs,
} from 'src/types/backend';

const MUTATION = gql`
  mutation ExtractBlogInstructionsFromUrl($sectionId: ID!, $url: String!, $projectId: ID) {
    extractBlogInstructionsFromUrl(sectionId: $sectionId, url: $url, projectId: $projectId) {
      instructions
      status
      extractionErrors
    }
  }
`;

type Variables = BackendMutationExtractBlogInstructionsFromUrlArgs;
type Result = Pick<
  BackendExtractedBlogInstructions,
  'instructions' | 'status' | 'extractionErrors'
>;

export const extractBlogInstructionsFromUrl = async (variables: Variables) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: {
      traceAcRequests: true,
    },
  });

  return getSingleProp<Result>(result.data);
};
